<template>
  <main role="KomplainDetail">
    <div class="row">
      <div class="col-md-12">
        <div class="card-on-card">
          <div class="card-body">
            <div class="card-on-card">
              <div class="card-body">
                <div class="card-group">
                  <!-- FOR PLACEHOLDER -->
                  <div
                    class="card cardPlaceholder"
                    style="background-color: rgb(250, 250, 250)"
                  >
                    <div class="card-body">
                      <h5
                        class="card-title mb-5"
                        style="font-size: 16.5px; font-weight: 700"
                      >
                        Barang Yang dikomplain
                      </h5>
                      <content-placeholders :animated="false">
                        <content-placeholders-heading :img="true" />
                        <content-placeholders-text :lines="3" />
                      </content-placeholders>
                    </div>
                  </div>
                  <div
                    class="card cardPlaceholder"
                    style="background-color: rgb(250, 250, 250)"
                  >
                    <div class="card-body">
                      <h5
                        class="card-title mb-5"
                        style="font-size: 16.5px; font-weight: 700"
                      >
                        Customer
                      </h5>
                      <div class="clearfix content-heading">
                        <content-placeholders :animated="false">
                          <content-placeholders-heading :img="true" />
                          <content-placeholders-text :lines="3" />
                        </content-placeholders>
                      </div>
                    </div>
                  </div>
                  <!-- END FOR PLACEHOLDER -->

                  <div class="card dataCard">
                    <div class="card-body">
                      <h5
                        class="card-title mb-5"
                        style="font-size: 16.5px; font-weight: 700"
                      >
                        Barang Yang dikomplain
                      </h5>
                      <div class="clearfix content-heading ml-3">
                        <img
                          class="pull-left mr-4"
                          :src="product.image"
                          alt="Card image cap"
                          width="30%"
                        />
                        <p class="card-text">
                          {{ product.name }}
                        </p>
                        <p class="card-text">
                          Harga :{{ product.priceCurrencyFormat }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="card dataCard">
                    <div class="card-body">
                      <h5
                        class="card-title mb-5"
                        style="font-size: 16.5px; font-weight: 700"
                      >
                        Customer
                      </h5>
                      <div class="clearfix content-heading">
                        <div class="ml-3">
                          <p class="card-text">
                            <b>{{ customer.name }}</b>
                          </p>
                          <p class="card-text">
                            {{ customer.address }}
                            {{ customer.district }}
                            {{ customer.city }}
                            {{ customer.province }}
                          </p>
                          <a
                            class="btn btn-xs btn-secondary"
                            id="btnFotoKomplain"
                            data-abc="true"
                            ><i class="fa fa-picture-o" aria-hidden="true"></i>
                            Foto Komplain</a
                          >

                          <div
                            class="modal fade"
                            id="imagePopup"
                            tabindex="-1"
                            role="dialog"
                          >
                            <div
                              class="modal-dialog modal-dialog-centered"
                              role="document"
                            >
                              <div
                                class="modal-content"
                                style="
                                  background-color: transparent;
                                  border: 0px;
                                "
                              >
                                <div
                                  class="modal-header"
                                  style="
                                    background-color: transparent;
                                    border: 0px;
                                  "
                                >
                                  <h5 class="modal-title" id="imagePopup"></h5>
                                  <button
                                    type="button"
                                    class="close"
                                    data-dismiss="modal"
                                    style="color: white"
                                    aria-label="Close"
                                  >
                                    <span aria-hidden="true">×</span>
                                  </button>
                                </div>
                                <div class="modal-body" id="imagePopup"></div>
                                <div
                                  class="modal-footer"
                                  style="border: 0px"
                                  id="imagePopup"
                                ></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- FOR PLACEHOLDER -->
            <div class="card-on-card card-bordered cardPlaceholder">
              <div class="card-header">
                <div
                  class="media media-chat float-left"
                  style="margin: -20px -20px -20px -21.5px"
                >
                  <img
                    class="avatar"
                    src="https://img.icons8.com/cotton/64/000000/user-male--v1.png"
                    alt="..."
                  />
                  <h4
                    class="card-title mt-3"
                    style="
                      font-size: 14px;
                      background-color: #d8d8d8;
                      color: #808080;
                      border: 0;
                      border-radius: 10px;
                      padding: 1px 10px 1px 10px;
                    "
                  >
                    ...
                  </h4>
                </div>
              </div>

              <div class="card-body">
                <content-placeholders :animated="false">
                  <content-placeholders-heading :img="true" />
                  <content-placeholders-text :lines="3" />
                </content-placeholders>
              </div>
            </div>

            <!-- END PLACHOLDER -->
            <!-- <button class="btn btn-danger">Tolak Komplain</button> -->

            <div class="card-on-card card-bordered dataCard">
              <div class="card-header">
                <div
                  class="media media-chat float-left"
                  style="margin: -20px -20px -20px -21.5px"
                >
                  <img
                    class="avatar"
                    src="https://img.icons8.com/cotton/64/000000/user-male--v1.png"
                    alt="..."
                  />
                  <h4
                    class="card-title mt-3"
                    style="
                      font-size: 14px;
                      background-color: #d8d8d8;
                      color: #808080;
                      border: 0;
                      border-radius: 10px;
                      padding: 1px 10px 1px 10px;
                    "
                  >
                    {{ customer.name }}
                  </h4>
                </div>
              </div>
              <div
                class="ps-container ps-theme-default ps-active-y chatBg"
                id="chat-content"
                style="overflow-y: scroll !important; height: 400px !important"
              >
                <main v-for="(comp, index) in complaint.message" :key="index">
                  <div v-if="comp.from == 'mall'">
                    <div class="media media-meta-day">{{ comp.createdAt }}</div>
                    <div class="media media-chat media-chat-reverse">
                      <div class="media-body">
                        <div class="text-right">
                          <p>
                            <span class="text-right font-weight-bold text-white"
                              >You</span
                            >
                            <br />
                            <span
                              class="font-weight-bolder text-white"
                              style="color: #fffff"
                            >
                              {{ comp.message }}
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="comp.from == 'admin'">
                    <div class="media media-meta-day">{{ comp.createdAt }}</div>
                    <div class="media media-chat media-chat-reverse">
                      <div class="media-body">
                        <div class="text-right">
                          <p style="background-color: goldenrod">
                            <span class="text-right font-weight-bold"
                              >Admin</span
                            ><br />{{ comp.message }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="media media-chat">
                      <img
                        class="avatar"
                        src="https://img.icons8.com/cotton/64/000000/user-male--v1.png"
                        alt="..."
                      />
                      <div class="media-body">
                        <p>{{ comp.message }}</p>
                        <p class="meta">{{ comp.createdAt }}</p>
                      </div>
                    </div>
                  </div>
                </main>

                <div class="ps-scrollbar-x-rail" style="left: 0px; bottom: 0px">
                  <div
                    class="ps-scrollbar-x"
                    tabindex="0"
                    style="left: 0px; width: 0px"
                  ></div>
                </div>
                <div
                  class="ps-scrollbar-y-rail"
                  style="top: 0px; height: 0px; right: 2px"
                >
                  <div
                    class="ps-scrollbar-y"
                    tabindex="0"
                    style="top: 0px; height: 2px"
                  ></div>
                </div>
              </div>
              <div class="publisher bt-1 border-light">
                <div class="photo">
                  <img
                    class="avatar avatar-xs"
                    src="https://cdn.eurekabookhouse.co.id/ebh/mall/EUREKAOFFICIAL_header_mall09_14_25.png"
                    style="
                      background-size: contain;
                      margin: 10px 10px 0px 0px;
                      background-color: white;
                    "
                    alt="..."
                  />
                </div>
                <input
                  class="publisher-input message_input"
                  type="text"
                  placeholder="Tulis Pesan..."
                />
                <button
                  class="publisher-btn text-info f"
                  id="inputChat"
                  data-abc="true"
                >
                  <i
                    id="loadingState"
                    class="fa fa-paper-plane"
                    aria-hidden="true"
                  ></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import $ from "jquery";
import axios from "axios";
// import { sleeper } from "/src/utils/sleeper.js";
export default {
  data() {
    return {
      parentData: {},
      product: {},
      customer: {},
      complaint: {},
      paramId: 0,
    };
  },
  created() {
    this.getResult();
  },
  mounted: function () {
    $(".dataCard").show();
    $(".cardPlaceholder").hide();
  },
  methods: {
    getResult() {
      var globalThis = this;
      this.paramId = this.$route.params.id;
      const urlDetailKomplain = `seller/complaint/${this.$route.params.id}`;
      axios
        .get(urlDetailKomplain)
        .then((res) => {
          return res.data.data;
        })
        // .then(sleeper(1000))
        .then((data) => {
          // $('.cardPlaceholder').hide();
          // $(".dataCard").show();
          this.parentData = data;
          this.product = data.product;
          this.customer = data.customer;
          this.complaint = data.complaint;

          $("#btnFotoKomplain").on("click", function () {
            const modalPicture = data.complaint.image;
            $("#imagePopup .modal-body").html(
              `<img src="${modalPicture}"` + "class='clicked' >"
            );
            $("#imagePopup").modal("toggle");
            $("#imagePopup .modal-content").css(
              "background-color",
              "transparent"
            );
            $("#imagePopup .modal-header").css(
              "background-color",
              "transparent"
            );
            $("#imagePopup .close").css("color", "white");
          });
        })
        .then(() => {
          var chatToBottom = document.getElementById("chat-content");
          chatToBottom.scrollTop = chatToBottom.scrollHeight;
          $("#inputChat").on("click", function () {
            if ($(".message_input").val() == "") {
              globalThis.$swal.fire({
                timer: 2000,
                title:
                  "<span class='text-muted font-weight-light' style='font-size:17px'>Komplain Tidak Boleh Kosong</span>",
                icon: "warning",
                showConfirmButton: false,
                width: 350,
              });
            } else {
              setTimeout(() => {
                $(".message_input").val("");
              }, 500);
              $("#loadingState")
                .removeClass("fa-paper-plane")
                .addClass("fa-circle-notch fa-spin disabled");
              $("#inputChat").attr("disabled", true);
              // $('.cardPlaceholder').show();
              // $(".dataCard").hide();
              axios
                .post("seller/complaint", {
                  id: globalThis.paramId,
                  message: $(".message_input").val(),
                })
                .then(() => {
                  $("#loadingState")
                    .removeClass("fa-circle-notch fa-spin")
                    .addClass("fa-paper-plane");
                  $("#inputChat").attr("disabled", false);
                  chatToBottom.scrollTop = chatToBottom.scrollHeight;
                  // $('.cardPlaceholder').hide();
                  // $(".dataCard").show();
                  globalThis.getResult();
                });
            }
          });
        });
    },
  },
};
</script>

<style scoped>
.card-bordered {
  border: 1px solid #ebebeb;
}

.card {
  border: 0;
  border-radius: 0px;
  margin-bottom: 30px;
  -webkit-box-shadow: 0 2px 3px rgba(0, 0, 0, 0.03);
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.03);
  -webkit-transition: 0.5s;
  transition: 0.5s;
}

.padding {
  padding: 3rem !important;
}

.card-header:first-child {
  border-radius: calc(0.25rem - 1px) calc(0.25rem - 1px) 0 0;
}

.card-header {
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
  padding: 15px 20px;
  background-color: transparent;
  border-bottom: 1px solid rgba(77, 82, 89, 0.07);
}

.card-header .card-title {
  padding: 0;
  border: none;
}

h4.card-title {
  font-size: 17px;
}

.card-header > *:last-child {
  margin-right: 0;
}

.card-header > * {
  margin-left: 8px;
  margin-right: 8px;
}

.btn-secondary {
  color: #4d5259 !important;
  background-color: #e4e7ea;
  border-color: #e4e7ea;
  color: #fff;
}

.btn-xs {
  font-size: 11px;
  padding: 2px 8px;
  line-height: 18px;
}

.btn-xs:hover {
  color: #fff !important;
}

.card-title {
  /* font-family: Roboto, sans-serif; */
  font-weight: 300;
  line-height: 1.5;
  margin-bottom: 0;
  padding: 15px 20px;
  border-bottom: 1px solid rgba(77, 82, 89, 0.07);
}

.ps-container {
  position: relative;
}

.ps-container {
  -ms-touch-action: auto;
  touch-action: auto;
  overflow: hidden !important;
  -ms-overflow-style: none;
}

.media-chat {
  padding-right: 64px;
  margin-bottom: 0;
}

.media {
  padding: 16px 12px;
  -webkit-transition: background-color 0.2s linear;
  transition: background-color 0.2s linear;
}

.media .avatar {
  flex-shrink: 0;
}

.media-chat .media-body {
  -webkit-box-flex: initial;
  flex: initial;
  display: table;
}

.media-body {
  min-width: 0;
}

.media-chat .media-body p {
  position: relative;
  padding: 6px 8px;
  margin: 4px 0;
  background-color: #f5f6f7;
  border-radius: 3px;
  font-weight: 100;
  color: #757575;
}

.media > * {
  margin: 0 8px;
}

.media-chat .media-body p.meta {
  background-color: transparent !important;
  padding: 0;
  opacity: 0.8;
}

.media-meta-day {
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
  margin-bottom: 0;
  color: #8b95a5;
  opacity: 0.8;
  font-weight: 400;
}

.media {
  padding: 16px 12px;
  -webkit-transition: background-color 0.2s linear;
  transition: background-color 0.2s linear;
}

.media-meta-day::before {
  margin-right: 16px;
}

.media-meta-day::before,
.media-meta-day::after {
  content: "";
  -webkit-box-flex: 1;
  flex: 1 1;
  border-top: 1px solid #ebebeb;
}

.media-meta-day::after {
  content: "";
  -webkit-box-flex: 1;
  flex: 1 1;
  border-top: 1px solid #ebebeb;
}

.media-meta-day::after {
  margin-left: 16px;
}

.media-chat.media-chat-reverse {
  padding-right: 12px;
  padding-left: 64px;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: reverse;
  flex-direction: row-reverse;
}

.media-chat {
  padding-right: 64px;
  margin-bottom: 0;
}

.media {
  padding: 16px 12px;
  -webkit-transition: background-color 0.2s linear;
  transition: background-color 0.2s linear;
}

.media-chat.media-chat-reverse .media-body p {
  float: right;
  clear: right;
  background-color: #43576b;
  color: #fff;
}

.media-chat .media-body p {
  position: relative;
  padding: 6px 8px;
  margin: 4px 0;
  background-color: #f5f6f7;
  border-radius: 3px;
}

.border-light {
  border-color: #f1f2f3 !important;
}

.bt-1 {
  border-top: 1px solid #ebebeb !important;
}

.publisher {
  position: relative;
  display: -webkit-box;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  padding: 12px 20px;
  background-color: #f9fafb;
}

.publisher > *:first-child {
  margin-left: 0;
}

.publisher > * {
  margin: 0 8px;
}

.photo {
  width: 34px;
  height: 34px;
  overflow: hidden;
  float: left;
  z-index: 5;
  margin-right: 10px;
  border-radius: 50%;
  margin-left: 23px;
  /* box-shadow: 0 10px 25px 0 rgba(0, 0, 0, .3); */
}

.publisher-input {
  -webkit-box-flex: 1;
  flex-grow: 1;
  border: none;
  outline: none !important;
  background-color: transparent;
}

button,
input,
optgroup,
select,
textarea {
  /* font-family: Roboto, sans-serif; */
  font-weight: 300;
}

.publisher-btn {
  background-color: transparent;
  border: none;
  color: #8b95a5;
  font-size: 16px;
  cursor: pointer;
  overflow: -moz-hidden-unscrollable;
  -webkit-transition: 0.2s linear;
  transition: 0.2s linear;
}

.file-group {
  position: relative;
  overflow: hidden;
}

.publisher-btn {
  background-color: transparent;
  border: none;
  color: #cac7c7;
  font-size: 16px;
  cursor: pointer;
  overflow: -moz-hidden-unscrollable;
  -webkit-transition: 0.2s linear;
  transition: 0.2s linear;
}

.file-group input[type="file"] {
  position: absolute;
  opacity: 0;
  z-index: -1;
  width: 20px;
}

.text-info {
  color: #3d5b6e !important;
}
</style>